module.exports = "<header>\r\n  <div class=\"logo\"   *ngIf=\"user != null\" [routerLink]=\"['/homemenu']\"   >\r\n\r\n\r\n\r\n  </div>\r\n\r\n  <div class=\"phone\" >{{user == null ? 'sign in please' : user.lastName}}\r\n\r\n    <br>\r\n\r\n  </div>\r\n\r\n  <div class=\"lout\" *ngIf=\"user != null\" (click)=\"logut()\"   >\r\n    <!--[hidden] ={{user == null}}-->\r\n    <!--{{user == null ? 'МОЛЯ ВПИШЕТЕ СЕ' : user.lastName}}-->\r\n  </div>\r\n\r\n</header>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.html
// module id = ./src/app/shared/header/header.component.html
// module chunks = main